<template>
  <div id="app">
    <Navbar />
    <Banner />
    <Sobre />
    <Projetos />
    <!-- <Servicos /> -->
    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Banner from "./components/Banner.vue";
import Sobre from "./components/sobre.vue";
import Projetos from "./components/Projetos.vue";
// import Servicos from './components/Servicos.vue';

import Footer from "./components/footer.vue";


export default {
  name: "App",
  components: {
    Navbar,
    Banner,
    // Servicos,
    Sobre,
    Projetos,
    Footer,
  },
};
</script>

<style>
#app {
  font-family: "Montserrat-VariableFont_wght";

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  font-family: "Montserrat-VariableFont_wght" !important;
}

h1 {
  font-family: "Montserrat-VariableFont_wght" !important;
}

p {
  font-size: 22px;
  font-family: "Montserrat-VariableFont_wght" !important;
}
button {
  font-family: "Montserrat-VariableFont_wght" !important;
}
a {
  font-family: "Montserrat-VariableFont_wght" !important;
}

@font-face {
  font-family: Montserrat-VariableFont_wght;
  src: url("~@/assets/Montserrat-VariableFont_wght.ttf");
}
</style>
